module.exports = __webpack_public_path__ + "img/www.findlaw.com.665d4de5.png";